import React from 'react';
import {Text, TextMessage} from 'components/tt-forms/common';
import moment from 'moment';

class NhiemVuTTXM extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    let lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    let lb2 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
    return (
      <section className="wrap-block">
        <h2 className="title-14 mb15">Nhiệm vụ thẩm tra xác minh{lb2}</h2>
        <div className="row pl10 pr10">
          <div className="col-100 no-gutter mb15">
            <Text className="col-25" label="Ngày chuyển:" value={this.props.ngayBatDauTTXM ? moment(this.props.ngayBatDauTTXM).format('DD/MM/YYYY') : ''}/>
            <Text className="col-25" label={"Đơn vị giao "+lb1+":"} value={this.props.donViGiaoThamTraXacMinh ? this.props.donViGiaoThamTraXacMinh.ten : ''}/>
            <Text className="col-25" red ={true} label="Thời gian báo cáo kết quả:" value={this.props.ngayHetHanTTXM ? moment(this.props.ngayHetHanTTXM).format('DD/MM/YYYY') : ''}/>
          </div>
          <div className="col-100 no-gutter">
            <TextMessage className="col-100" label={"Ý kiến của đơn vị giao "+lb1+":"} value={this.props.yKienCuaDonViGiaoTTXM ? this.props.yKienCuaDonViGiaoTTXM : ''}/>
          </div>
        </div>
      </section>
    );
  }
}

NhiemVuTTXM.defaultProps = {
  donViGiaoThamTraXacMinh: {
    ten: ''
  },
  ngayHetHanTTXM: '',
  yKienCuaDonViGiaoTTXM: '',
  ngayBatDauTTXM: ''
}

export default NhiemVuTTXM;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/NhiemVuTTXM.jsx